angular.module('impactx.search').controller('SearchListTenderCtrl', SearchListTenderController);
SearchListTenderController.$inject = [
    '$scope',
    'searchFilter',
    'AddToBasketService',
    'SearchService',
    'AppConfiguration',
    'SearchFilter',
    'dataGen',
    'ToolbarService',
    'TranslationService',
    'DownloadService',
    '$routeParams',
    'SearchFilterStorage',
    '$rootScope',
    '$location',
    'BackService'
];

function SearchListTenderController($scope, searchFilter, AddToBasketService, SearchService, AppConfiguration, SearchFilter,
                                    dataGen, ToolbarService, TranslationService, DownloadService, $routeParams,
                                    SearchFilterStorage, $rootScope, $location, BackService) {
    var self = this;
    self.pageNumber = 1;
    self.showScrollTopButton = false;
    self.showResultsAsList = AppConfiguration.get('displayAllResultsAsList');
    var routeChangeFinished = false;
    self.resetPageNumber = {value: false};
    ToolbarService.showSearchFilterToggle();
    var backButtonUsed = $rootScope.location !== $location.path();

    self.search = function (index) {
        if (!index) {
            self.resetPageNumber.value = true;
            self.pageNumber = 1;
        }
        else {
            self.pageNumber = index;
        }

        return SearchService.searchTenders(self.pageNumber).then(function (searchResults) {
            self.initialized = true;
            if (searchResults) {
                angular.extend(self, searchResults);
                defineButtons();
                if(backButtonUsed) {
                    SearchFilterStorage.scrollToSearchScrollPosition("tenderList", '#search-view');
                }
            }
        });
    };


    var currentLocation = $location.path();
    var backButtonUsed = $rootScope.location !== currentLocation;
    var storedSearchFilterObject = SearchFilterStorage.getTenderListFilter();
    if (storedSearchFilterObject && backButtonUsed) {
        SearchFilterStorage.removeLastTenderListFilter();
        self.filter = storedSearchFilterObject;
        searchFilter.searchInput = self.filter.searchInput.value;
        var guidingClassification =  self.filter.guidingClassification;
        if (guidingClassification && guidingClassification.superEntries) {
            var superEntry = guidingClassification.superEntries[guidingClassification.superEntries.length - 1];
            SearchFilter.setSearchInputClassification(superEntry);
        }
        else {
            SearchFilter.setSearchInputClassification(null);
        }
        SearchFilter.setFilters(self.filter);
        self.search();
    }
    else {
        self.filter = JSON.parse(JSON.stringify(SearchFilter.getFilters()));
        SearchFilter.setFilters(self.filter);
        self.search();
    }

    $scope.$watch(function () {return $location.path()}, function () {
        //this is not triggered when the back button is used.
        if (routeChangeFinished) {
            var searchInputUsed = SearchFilter.getFilters().searchInputUsed;
            SearchFilter.getFilters().searchInputUsed = false;
            SearchFilterStorage.setTenderListFilter(self.filter);
            var searchInputClassification = SearchFilter.getSearchInputClassification();
            var guidingClassification = SearchFilter.getGuidingClassification();
            SearchFilter.setFilters(SearchFilterStorage.getFreshFilter());
            if (searchInputUsed) {
                SearchFilter.getFilters().searchInput.value = searchFilter.searchInput;
                SearchFilter.setSearchInputClassification(searchInputClassification);
                SearchFilter.setGuidingClassification(guidingClassification);
            }
            else {
                searchFilter.searchInput = "";
            }
            SearchFilterStorage.setSearchFilterPlaceHolder(null);
        }
        routeChangeFinished = true;
    });


    self.addToBasket = AddToBasketService.addToBasket;

    self.print = function () {
        var tenderIds = [];
        SearchService.searchTenders(self.pageNumber).then(function (searchResults) {
            if (searchResults) {
                angular.forEach(searchResults.tenders, function (tender) {
                    tenderIds.push(tender.id);
                });
                DownloadService.openDownloadPost('/search/export/tender', {paramName: "ids", paramValue: tenderIds});
            }
        });
    };

    self.showScrollTop = function (showScrollTop) {
        self.showScrollTopButton = showScrollTop;
    };

    self.scrollToTop = function () {
        angular.element('#search-view').animate({
            scrollTop: 0
        }, 200);
    };

    self.back = function () {
        BackService.back();
        self.filter.listFilters = SearchFilterStorage.getFreshFilter().listFilters;
    }

    function defineButtons() {
        var buttonDefinition = [
            {label: TranslationService.get("back"), action: self.back, type: 'dialogaction'},
            {
                label: TranslationService.get('print'),
                action: self.print
            }
        ];
        ToolbarService.hideBackButton();
        ToolbarService.setButtons(buttonDefinition);
    }

    function setRouteBasedFilter() {
        SearchFilter.setLotId($routeParams.lotId);
        SearchFilter.setSupplierId($routeParams.supplierId);
    }

    $scope.$on('$routeChangeStart', function (event, newRoute, oldRoute) {
        if (newRoute.$$route.originalPath !== oldRoute.$$route.originalPath) {
            SearchFilterStorage.setSearchScrollPosition("tenderList", document.getElementById('search-view').scrollTop);
        }
    });
}
